import { coreApi } from "../../app/core-api";
import { PagedResult, PagedSearchFilter } from "../../app/types";
import { ProductCreateDto, ProductListItem, ProductsFilter } from "./products.types";

const controller = "products";

export const productsApi = {
    searchProducts,
    getProduct,
    createProduct,
    updateProduct,
    deleteProduct,
};

function searchProducts(filter: PagedSearchFilter<ProductsFilter>) {
    return coreApi.get<PagedResult<ProductListItem>>(`${controller}`, {
        ...filter.filter,
        ...filter.pagination,
    });
}

function getProduct(id: string) {
    return coreApi.get<ProductListItem>(`${controller}/${id}`);
}

function createProduct(data: ProductCreateDto) {
    return coreApi.post<{ id: string }>(controller, data);
}

function updateProduct(id: string, data: ProductCreateDto) {
    return coreApi.put<{ id: string }>(`${controller}/${id}`, data);
}

function deleteProduct(id: string) {
    return coreApi.remove(`${controller}/${id}`);
}
